import { useState, useEffect } from "react";
import apis from '../api';

const useParamsCIRVoucher = () => {
    const [params, setParams] = useState([]);
    const headers = {
        authorization: localStorage.getItem('token')
    }
    let payload = {
        CLIENT: localStorage.getItem('client'),
        ENTITY: localStorage.getItem('entity'),
        OPTION: "2"
    }
    useEffect(() => {
        const getParams = async () => {
            let parametros = [];
            let lista = [];
            await apis.postPDFCIRVoucher(payload, headers).then(res => {
                parametros = res.data["PDF"]
                console.log(parametros)
            })
            parametros.forEach((element, index) => {
                element["DETAIL"].forEach((row, i) => {
                    if (row.LABEL === 'p_persona') {
                        lista = row.DETAIL
                    }
                })
            })
            setParams(lista)
        }
        getParams()
    }, []);

    return [params];
};

export default useParamsCIRVoucher;